/**
 * Brand Configuration
 *
 * Reads REACT_APP_BRAND env var and exports brand-specific values.
 * Default brand is 'hotelsontap' to preserve existing behavior.
 */

const BRAND = (process.env.REACT_APP_BRAND || 'hotelsontap').toLowerCase();

const BRANDS = {
  hotelsontap: {
    systemName: 'HOTELS ON TAP',
    shortName: 'YUL ON TAP',
    portalTitle: 'HOTELS ON TAP',
    loginPlaceholder: 'admin@hotelsontap.com',
    domain: 'hotelsontap.com',
    primaryColor: '#3b82f6',
    loginIconBg: 'bg-blue-600',
    loginButtonBg: 'bg-blue-600 hover:bg-blue-700',
    accentColor: '#3b82f6',
    // Terminology (hotel-specific)
    terms: {
      propertySectionSuperAdmin: 'Your Properties',
      propertySectionClientAdmin: 'Your Properties',
      propertyInfoTitle: 'Property Information',
      propertyInfoDesc: 'Enter the basic information about your property',
      propertyInfoEditDesc: 'Update your property details',
      propertyTypeLabel: 'Property Type',
      selectBusiness: 'Select Hotel',
      businessName: 'Hotel Name',
      businessCode: 'Hotel Code',
      businessCodeDesc: 'Short unique code for this property. Used as prefix for card/tag URLs.',
      addProperty: 'Add Property',
      addPropertyFr: 'Ajouter une propriété',
      addPropertyEs: 'Agregar propiedad',
      noPropertiesYet: 'No properties yet',
      noPropertiesYetFr: 'Aucune propriété',
      noPropertiesYetEs: 'Sin propiedades aún',
      noPropertiesDesc: 'Add your first property to start collecting reviews and guest feedback.',
      noPropertiesDescFr: 'Ajoutez votre première propriété pour commencer à collecter des avis et des sondages.',
      noPropertiesDescEs: 'Agregue su primera propiedad para comenzar a recopilar reseñas y feedback.',
      propertySectionFr: 'Vos Propriétés',
      propertySectionEs: 'Sus propiedades',
      addButtonFr: 'Ajouter',
      addButtonEs: 'Agregar',
      addButton: 'Add',
      businessNamePlaceholder: 'Grand Plaza Hotel',
      businessCodePlaceholder: 'SHERMTL',
      codeHelpText: 'Used as prefix for tag IDs',
    },
  },
  tapelligence: {
    systemName: 'TAPELLIGENCE',
    shortName: 'TAPELLIGENCE',
    portalTitle: 'TAPELLIGENCE',
    loginPlaceholder: 'admin@tapelligence.com',
    domain: 'tapelligence.com',
    primaryColor: '#0d9488',
    loginIconBg: 'bg-teal-600',
    loginButtonBg: 'bg-teal-600 hover:bg-teal-700',
    accentColor: '#0d9488',
    // Terminology (generic multi-industry)
    terms: {
      propertySectionSuperAdmin: 'Clients',
      propertySectionClientAdmin: 'Your Locations',
      propertyInfoTitle: 'Client Information',
      propertyInfoDesc: 'Enter the basic information about your business',
      propertyInfoEditDesc: 'Update your business details',
      propertyTypeLabel: 'Industry Type',
      selectBusiness: 'Select Business',
      businessName: 'Business Name',
      businessCode: 'Business Code',
      businessCodeDesc: 'Short unique code for this business. Used as prefix for card/tag URLs.',
      addProperty: 'Add Client',
      addPropertyFr: 'Ajouter un client',
      addPropertyEs: 'Agregar cliente',
      noPropertiesYet: 'No clients yet',
      noPropertiesYetFr: 'Aucun client',
      noPropertiesYetEs: 'Sin clientes aún',
      noPropertiesDesc: 'Add your first client to start managing locations and operations.',
      noPropertiesDescFr: 'Ajoutez votre premier client pour commencer à gérer les emplacements.',
      noPropertiesDescEs: 'Agregue su primer cliente para comenzar a gestionar ubicaciones.',
      propertySectionFr: 'Clients',
      propertySectionEs: 'Clientes',
      addButtonFr: 'Ajouter',
      addButtonEs: 'Agregar',
      addButton: 'Add',
      businessNamePlaceholder: 'Acme Corporation',
      businessCodePlaceholder: 'ACMECO',
      codeHelpText: 'Used as prefix for tag IDs',
    },
  },
};

const brandConfig = BRANDS[BRAND] || BRANDS.hotelsontap;

// Industry types for Tapelligence (multi-industry dropdown)
const INDUSTRY_TYPES = [
  { value: 'casino', label: 'Casino' },
  { value: 'hotel', label: 'Hotel' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'retail', label: 'Retail' },
  { value: 'restaurant', label: 'Restaurant' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'airport', label: 'Airport' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'office', label: 'Office' },
  { value: 'property_management', label: 'Property Management' },
  { value: 'logistics', label: 'Logistics / Distribution' },
  { value: 'other', label: 'Other' },
];

export default brandConfig;
export { BRAND, INDUSTRY_TYPES };
